import * as React from 'react'
import Polygon from '../../icons/ui/Polygon'
import Select from 'react-select'
import { ISelectedAccommodation } from './Accommodations'
import Clear from '../../icons/vehicle/Close'

interface IAccommodationTagProps {
  accommodation: ISelectedAccommodation
  handleRemove: (keyInArray: string) => void
  handleSelectAmount: (id: string, value: number) => void
}

interface IAccommodationTagState {}

class AccommodationTag extends React.Component<IAccommodationTagProps, IAccommodationTagState> {
  private seatAmountOptions = [
    {
      value: 1,
      label: '1'
    },
    {
      value: 2,
      label: '2'
    },
    {
      value: 3,
      label: '3'
    },
    {
      value: 4,
      label: '4'
    },
    {
      value: 5,
      label: '5'
    }
  ]

  public render() {
    return (
      <div className='flex p1 items-center relative col-6'>
        <div className='h5 bold font-blue-grey col-3 cursor--pointer fit'>{this.props.accommodation.name}</div>
        <Polygon className={'icon--10x10 ml1'} />
        <div className='h5 bold font-blue-grey mx1'>
          <Select
            options={this.seatAmountOptions}
            value={{ value: this.props.accommodation.number, label: this.props.accommodation.number.toString() }}
            onChange={this.handleSelectAmount}
            placeholder='Choose amount'
            clearable={false}
          />
        </div>
        <div onClick={this.handleRemove} className='cursor--pointer mr1'>
          <Clear />
        </div>
      </div>
    )
  }

  private handleSelectAmount = (option: { value: number; label: string }) => {
    this.props.handleSelectAmount(this.props.accommodation.accommodationId, option.value)
  }

  private handleRemove = () => {
    this.props.handleRemove(this.props.accommodation.accommodationId)
  }
}

export default AccommodationTag



// WEBPACK FOOTER //
// ./src/components/vehicles/edit-vehicle/AccommodationTag.tsx